import { palette } from 'cds/styles';
import { FC } from 'react';
import styled from 'styled-components';

const Section2: FC = () => {
  return (
    <section>
      <L_Section2Container>
        <L_Section2>
          <div>클래스유 Biz와 함께 성장하는 고객사</div>
        </L_Section2>
      </L_Section2Container>
    </section>
  );
};

const L_Section2Container = styled.div`
  width: auto;
  padding-left: 2rem;
  padding-right: 2rem;
  color: #000;
  @media (min-width: 1280px) {
    padding-left: 0;
    padding-right: 0;
  }

  @media (min-width: 960px) {
    margin-left: auto;
    margin-right: auto;
    padding-left: 0;
    padding-right: 0;
    max-width: 98rem;
  }

  @media (min-width: 1024px) {
    width: 100%;
    margin: 0 auto;
    max-width: 98rem;
  }
`;
const L_Section2 = styled.div`
  padding-top: 10rem;
  padding-bottom: 4rem;
  @media (min-width: 1024px) {
    width: 100%;
    margin: 0 auto;
    max-width: 98rem;
  }
  & > div {
    font-weight: 700;
    color: inherit;
    max-width: 98rem;
    padding-bottom: 1.8rem;
    font-size: 2.4rem;
    text-align: center;
    color: ${palette.grey75};
  }
`;

export default Section2;
